"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmailCampaignWildcards = void 0;
var EmailCampaignWildcards;
(function (EmailCampaignWildcards) {
    EmailCampaignWildcards["clientName"] = "clientName";
    EmailCampaignWildcards["year"] = "year";
    EmailCampaignWildcards["unsubscribeUrl"] = "unsubscribeUrl";
    EmailCampaignWildcards["petPortalLinksForClients"] = "petPortalLinksForClients";
    EmailCampaignWildcards["clinicLogo"] = "clinicLogo";
    EmailCampaignWildcards["clinicName"] = "clinicName";
    EmailCampaignWildcards["clinicPhoneNumber"] = "clinicPhoneNumber";
})(EmailCampaignWildcards = exports.EmailCampaignWildcards || (exports.EmailCampaignWildcards = {}));
//# sourceMappingURL=EmailCampaignWildcards.js.map